export default "__VITE_ASSET__BzlESVX7__"